import R from "ramda";

export const getGridNum = (className, gridType) => {
  let list;
  const isValidColumn =
    R.contains("col-sm-", className) || R.contains("col-xs-", className);

  if (R.not(isValidColumn)) {
    return 0;
  }

  switch (gridType) {
    case "sm":
      list = R.split("col-sm-")(className);
      break;
    case "xs":
    default:
      list = R.split("col-xs-")(className);
      break;
  }
  return parseInt(list[1], 10) || 0;
};

export const convertClassName = className => {
  const defaultClassName = "col-xs-12 col-sm-12";
  if (R.isNil(className) || R.isEmpty(className)) {
    return defaultClassName;
  }
  const classNameList = R.split(" ")(className);
  const hasAnyGrid = R.find(each => each.indexOf("col-") > -1)(classNameList);

  if (R.not(hasAnyGrid)) {
    return className;
  }

  const includeBothGrid =
    R.contains("col-sm", className) && R.contains("col-xs", className);

  if (includeBothGrid) {
    return className;
  }

  if (R.contains("col-sm", className)) {
    // only contains col-sm
    return `${className} col-xs-12`;
  }

  if (R.contains("col-xs", className)) {
    // only contains col-xs
    const xsClassName = R.find(each => each.indexOf("col-xs") > -1)(
      classNameList
    );
    const xsGridNum = getGridNum(xsClassName, "xs");
    return `${className} col-sm-${xsGridNum}`;
  }

  return className;
};

/* Only support col-xs and col-sm these 2 type of column for now.
 * 1. should convert the className to include both column
 *    - if only has col-sm, the col-xs's number should be 12
 *    - if only has col-xs, the col-sm's number should equal to col-xs's
 * 2. should calculate the grid number for each column
 * */

export default (list = [], data = {}) => {
  if (R.isEmpty(list) || R.type(list) !== "Array") {
    return false;
  }

  if (R.isEmpty(data) || R.type(data) !== "Object") {
    return false;
  }

  let xs_counter = 0;
  let sm_counter = 0;

  return R.reduce((acc, name) => {
    let newList = [];
    const item = data[name] || {};

    const convertedClassName = convertClassName(item.grid);
    const classNameList = R.split(" ")(convertedClassName);

    R.map(className => {
      if (R.contains("col-xs", className)) {
        const xs_num = getGridNum(className, "xs");
        xs_counter += xs_num === 12 ? 0 : xs_num;
      }
      if (R.contains("col-sm", className)) {
        const sm_num = getGridNum(className, "sm");
        sm_counter += sm_num === 12 ? 0 : sm_num;
      }
    })(classNameList);

    xs_counter = xs_counter === 24 ? 0 : xs_counter;
    sm_counter = sm_counter === 24 ? 0 : sm_counter;

    if (xs_counter > 12 && sm_counter > 12) {
      newList = ["clearfix"];
      xs_counter -= 12;
      sm_counter -= 12;
    } else if (xs_counter > 12) {
      newList = ["xs-clearfix"];
      xs_counter -= 12;
    } else if (sm_counter > 12) {
      newList = ["sm-clearfix"];
      sm_counter -= 12;
    }

    return [...acc, ...[...newList, name]];
  }, [])(list);
};
